import axios from "axios";
import { Language } from "../models";

export const getLanguages = () => {
    return axios.get<Language[]>(`Languages`);
}